import { forwardRef, type Ref, type SVGProps } from "react";

function SvgUserFilled(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0M3.744 21A.745.745 0 0 1 3 20.25v-1.5A4.75 4.75 0 0 1 7.75 14h8.5A4.75 4.75 0 0 1 21 18.75v1.5c0 .414-.33.75-.744.75z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgUserFilled);
export default ForwardRef;
